import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent } from 'rxjs';

/**
 * To be used for mobile apps, where this app launch inside an iframe (embedded page).
 * This service helps to configure and receive message from the embedding app (mobile).
 */
@Injectable({
  providedIn: 'root',
})
export class AppEmbedService {
  private embeddedState$ = new BehaviorSubject<boolean>(false);
  private _embedRequestData: { redirectId: string; redirectUrl: string };

  constructor(private location: Location, private router: Router) {}

  private _originWhitelist(origin: string) {
    const whitelist = [
      'localhost',
      'capacitor',
      'periksa.tech',
      'periksa.id',
      'mobileperiksa',
      'gigi.id',
    ];

    if (new RegExp(whitelist.join('|')).test(origin.toLowerCase())) {
      return true;
    }
    return false;
  }

  private _processMessage(event: MessageEvent) {
    const { data: payload, origin } = event;

    if (!this._originWhitelist(origin)) {
      return;
    }

    if (payload.type === 'emb_app') {
      switch (payload.data) {
        case 'register':
          this.embeddedState$.next(true);
          break;
        case 'nav-back':
          this.location.back();
          break;
        case 'nav-forward':
          this.location.forward();
          break;
        default:
          return;
      }
    }
  }

  /** Init message listener which will receive `window.postMessage()`
   * from the parent embedding app.
   */
  private _initMessageListener() {
    fromEvent(window, 'message').subscribe((ev: MessageEvent) => {
      this._processMessage(ev);
    });
  }

  public getEmbeddedState() {
    return this.embeddedState$.asObservable();
  }

  public get embedRequestData() {
    return this._embedRequestData;
  }

  public setEmbedString(val: { redirectId: string; redirectUrl: string }) {
    this._embedRequestData = val;
  }

  public init() {
    this._initMessageListener();
  }
}
